// Angular
import { Component, Input, OnInit } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import {Router} from '@angular/router';
import { AuthService } from '../../../../pages/auth/auth.service';
import {UserService} from '../../../../../core/_services/user.service';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user;

	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private router: Router,
		private authService: AuthService,
		private userService: UserService,
		private permissionsService: NgxPermissionsService
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.user = this.authService.user; // JSON.parse(localStorage.getItem('user'));
		if (this.user && this.user.name) {
			this.user.name = this.toCamelCase(this.user.name);
		}
	}
	private toCamelCase(value: string): string {
		if (!value) return '';
		return value
			.toLowerCase()
			.split(/[\s_]+/) // split by space or underscore
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join('');
	}
	/**
	 * Log out
	 */
	logout() {
		const refreshToken = localStorage.getItem('refreshToken');
		this.userService.logOut({ refresh: refreshToken }).subscribe(
			data => {},
			error => console.error("Failed to notify Finbase Auth logout:", error)
		);
		localStorage.clear();
		this.authService.user = null;
		this.authService.permissions = [];
		this.permissionsService.flushPermissions();
		this.router.navigate(['/auth/login']);
	}
}
